<template>
  <div>
    <hbt-capa />
    <hbt-livro /> 
    <!-- <hbt-guia />  -->
    <hbt-atalhos />
    <!-- <hbt-beneficios />
    <hbt-turmas-anteriores /> -->
    <hbt-sobre />
    <hbt-treinamentos />
    <hbt-treinamentos2 />
    <hbt-newsletter /> 
    <hbt-servicos />
    <hbt-terapeutas/>
    <hbt-blog />
    <hbt-contato/>  
    <hbt-rodape />
  </div>
</template>

<script>
import HbtCapa from '../components/Capa';
import HbtLivro from '../components/Livro';
import HbtAtalhos from '../components/Atalhos';
// import HbtFrases from '../components/Frases';
// import HbtBeneficios from '../components/Beneficios';
// import HbtTurmasAnteriores from '../components/TurmasAnteriores';
import HbtSobre from '../components/Sobre';
import HbtTreinamentos from '../components/Treinamentos';
import HbtTreinamentos2 from '../components/Treinamentos2';
import HbtNewsletter from '../components/Newsletter';
import HbtServicos from '../components/Servicos';
import HbtTerapeutas from '../components/Terapeutas';
// import HbtBonus from '../components/Bonus';
// import HbtInspiracao from '../components/Inspiracao';
// import HbtInscricao from '../components/Inscricao';
import HbtBlog from '../components/Blog';
import HbtContato from '../components/Contato';
import HbtRodape from '../components/Rodape';

export default {
  name: 'App',
  props:['endtime'],
  components: {
    HbtCapa,
    // HbtGuia,
    HbtLivro,
    HbtAtalhos,
    // HbtBeneficios,
    // HbtTurmasAnteriores,
    HbtSobre,
    HbtTreinamentos,
    HbtTreinamentos2,
    HbtNewsletter,
    HbtServicos,
    HbtTerapeutas,
    // HbtInscricao,
    HbtBlog,
    HbtContato,
    HbtRodape
  },

  data: () => ({
    //
  }),
  mounted () {
  }
  
};
</script>